import { createTimeouts } from "./timeouts";
import { useInit } from './hookUtils';
// import * as React from "react";

// const useTimeouts = () => React.useState(createTimeouts)[0];
const useTimeouts = () => useInit(createTimeouts);

export { useTimeouts }
